import * as z from 'zod';

const ip = z.union([z.ipv4(), z.ipv6()]);

export function ipSchema(version?: 'v4' | 'v6', optional = true) {
  return z.string().refine(
    (v) => {
      if (optional) {
        return v?.trim() === '' ? true : ip.safeParse(v).success;
      }
      if (!version) {
        console.log(version);
      }
      return ip.safeParse(v).success;
    },
    {
      error: 'Invalid IP Address',
    }
  );
}
